import styles from "./toggleFullScreenLayout.module.css";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import VideoAlert from "../video-alert";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import ScrollToPlugin from "gsap/src/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const ToggleFullScreenLayout = ({
  data,
  direction = "forward",
  language = "cn",
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [mobileActiveIndex, setMobileActiveIndex] = useState(0);

  const navScrollIng = useRef(false);
  const ctnRef = useRef(null);
  const mobileTabRef = useRef(null);
  const imgBox = useRef(null);
  const pcTabRef = useRef(null);

  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.playVideoButton}`,
    });
  }, []);

  useEffect(() => {
    init()
  })

  useEffect(() => {
    window.addEventListener('resize',init);
    return window.removeEventListener('resize',init)
  },[])

  const init = () => {
    let h5Ele = pcTabRef.current.querySelectorAll(`.toggleFullScreenLayoutH5`)[
      activeIndex
    ];
    let h2Ele = pcTabRef.current.querySelectorAll(`.${styles.contentItem}`)[
      activeIndex
    ].firstElementChild;
    ctnRef.current.style.setProperty(
      "--effect-height",
      `${h5Ele.offsetHeight}px`
    );
    ctnRef.current.style.setProperty(
      "--effect-track-height",
      `${h2Ele.offsetHeight + h5Ele.offsetHeight}px`
    );

    let offsetTop = 0;

    for (let j = 0; j < activeIndex; j++) {
      offsetTop +=
        pcTabRef.current.querySelectorAll(`.${styles.contentItem} > h3`)[j]
          .offsetHeight + 24;
    }

    ctnRef.current.style.setProperty("--effect-track-top", `${offsetTop}px`);
  };

  // const navScroll = (index) => {
  //   if (index < 0) {
  //     return;
  //   }
  //   // let scrollLeft = mobileTabRef.current.querySelectorAll(
  //   //   `.${styles.contentItem}`
  //   // )[index].offsetLeft;
  //   console.log(index);

  //   let currentTab = mobileTabRef.current.querySelectorAll(
  //     `.${styles.contentItem}`
  //   )[index];
  //   if (currentTab) {
  //     ctnRef.current.style.setProperty(
  //       "--effect-path-width",
  //       `${currentTab.offsetWidth}px`
  //     );

  //     gsap.to(mobileTabRef.current.lastElementChild, {
  //       duration: 0.6,
  //       scrollTo: {
  //         x: currentTab,
  //         offsetX: 24,
  //       },
  //       onComplete: () => {
  //         navScrollIng.current = false;
  //       },
  //       ease: "power2",
  //     });
  //   }
  // };

  const contentScroll = (index) => {
    console.log(imgBox.current.querySelectorAll(`.${styles.imgItem}`)[index]);
    gsap.to(window, {
      duration: 0.6,
      scrollTo: {
        y: imgBox.current.querySelectorAll(`.${styles.imgItem}`)[index],
        offsetY: `${mobileTabRef.current.offsetHeight - 1}`,
      },
      ease: "power2",
    });
  };

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div
        className={styles.contentBox}
        style={{
          gridColumn: direction === "forward" ? "1 / 2" : "2 / 3",
          gridRow: "1 / 2",
        }}
      >
        <h6>{data.smallHeader}</h6>
        <h1>{data.header}</h1>
        <div className="pc" ref={pcTabRef}>
          <div className={styles.track}></div>
          <div className={styles.path}></div>
          <div className={styles.contentItems}>
            {data.contents.map((item, index) => {
              return (
                <div
                  className={`${styles.contentItem} ${
                    index === activeIndex ? "active" : ""
                  }`}
                >
                  <h3
                    onClick={(e) => {
                      setActiveIndex(index);
                    }}
                    dangerouslySetInnerHTML={{
                      __html: item.title,
                    }}
                  ></h3>

                  <div className={`${styles.bodyBox}`}>
                    <div className='toggleFullScreenLayoutH5'>
                      <h5
                        dangerouslySetInnerHTML={{
                          __html: item.body,
                        }}
                      ></h5>
                      {item.note ? (
                        <h6
                          dangerouslySetInnerHTML={{
                            __html: item.note,
                          }}
                        ></h6>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div
        className={styles.imgBox}
        ref={imgBox}
        style={{
          gridColumn: direction === "forward" ? "2 / 3" : "1 / 2",
          gridRow: "1 / 2",
        }}
      >
        {data.contents.map((item, index, mediaType = "img") => {
          return (
            <div>
              <h3
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
              ></h3>
              <div className={styles.imgItem}>
                {mediaType === "img" ? (
                  <img
                    src={item.img}
                    alt="WEEBILL 3"
                    style={{
                      opacity: index === activeIndex ? "1" : "0",
                    }}
                    // onLoad={() => {
                    //   ScrollTrigger.refresh();
                    // }}
                  />
                ) : (
                  <video
                    src={item.video}
                    style={{
                      opacity: index === activeIndex ? "1" : "0",
                    }}
                    poster={item.img}
                    autoPlay
                    loop
                    playsInline
                    muted
                    preload="true"
                  ></video>
                )}

                <h5
                  dangerouslySetInnerHTML={{
                    __html: item.body,
                  }}
                ></h5>

                {item.note ? (
                  <h6
                    dangerouslySetInnerHTML={{
                      __html: item.note,
                    }}
                  ></h6>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ToggleFullScreenLayout;
